import React from 'react';
import SideBarLayout from './Components/SidebarLayout/SidebarLayout';
import './CustomLayout.scss';
const customLayoutRendererMap = {
  layout_type_sidebar: SideBarLayout
};
const CustomLayoutComponent = ({
  type,
  data
}) => {
  const CustomLayoutRenderer = customLayoutRendererMap[type];
  if (!CustomLayoutRenderer) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "CustomLayout"
  }, /*#__PURE__*/React.createElement(CustomLayoutRenderer, data));
};
export default CustomLayoutComponent;